export default {
  getServices(state) {
    return state.services;
  },
  getServiceList(state) {
    return state.serviceList;
  },
  getService(state) {
    return state.service;
  },
  getSearchServicesPayload(state) {
    return state.searchServicesPayload;
  },
  getLastSearchServicePayload(state) {
    return state.lastSearchServicePayload;
  },
  getLastSearchServicesPayload(state) {
    return state.lastSearchServicesPayload;
  },
};
